import { Typography } from 'enable-ui';

import { type OnboardingAnswer, TestMethod } from 'modules/learners/core/type';

import { ReactComponent as NoteIcon } from 'assets/icons/note-32.svg';

import { convertToTimeString } from 'helpers';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { MAX_ADDITIONAL_SCORE } from '../../../../constants';
import { FunctionalTest } from './FunctionalTest';

interface Props {
  idx: number;
  answer: OnboardingAnswer;
  handleViewNote: () => void;
}

export const CollapseBodyContent = ({ idx, answer, handleViewNote }: Props) => {
  const headerStyles = {
    color: '#222',
    fontSize: 16,
    fontWeight: 400,
  };

  const isAddition =
    answer.functionalTest.method === TestMethod['Enter score'] && answer.functionalTest.isAddition;

  const maxScore = answer.functionalTest.maxScore;
  const totalMaxScore = isAddition ? maxScore + MAX_ADDITIONAL_SCORE : maxScore;

  const score = Math.min(answer.score, answer.functionalTest.maxScore) || 0;
  const totalScore = isAddition
    ? score + Math.min(answer.scoreAddition, MAX_ADDITIONAL_SCORE)
    : score;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
        padding: '24px 0',
        background: COLOR_CONFIG.doctor,
      }}
    >
      <Typography style={{ ...headerStyles, width: 48, paddingLeft: 8 }}>{idx + 1}.</Typography>
      <div style={{ flexGrow: 1, width: 0 }}>
        <FunctionalTest item={answer.functionalTest} />
      </div>
      <Typography style={{ ...headerStyles, width: 150 }}>
        {[TestMethod['Enter rep count'], TestMethod['Enter score']].includes(
          answer.functionalTest.method,
        )
          ? `${totalScore} / ${totalMaxScore}`
          : '_'}
      </Typography>
      <div style={{ width: 321 }}>
        {answer.functionalTest.method === TestMethod['Enter rep count'] ? (
          <Typography style={headerStyles}>Reps: {answer.score}</Typography>
        ) : null}
        {isAddition && answer.scoreAddition ? (
          <Typography style={headerStyles}>Reps in 30s: {answer.scoreAddition || '_'}</Typography>
        ) : null}
        {answer.functionalTest.method !== TestMethod['Kg'] ? (
          <Typography style={headerStyles}>
            {isAddition ? 'Time for 5 reps' : 'Time'}: {convertToTimeString(answer.timeCount, true)}
          </Typography>
        ) : (
          <Typography style={headerStyles}>Weight: {answer.score} kg</Typography>
        )}
        {/* {answer.functionalTest.method === TestMethod['Enter rep count'] &&
        answer.functionalTest.isSO2AndHR ? (
          <>
            <Typography style={headerStyles}>
              Pre-test: SpO2 = {answer.preSpO2 ? `${answer.preSpO2}%` : '_'}, HR ={' '}
              {answer.preHR ? `${answer.preHR} bpm` : '_'}
            </Typography>
            <Typography style={headerStyles}>
              Post-test: SpO2 = {answer.postSpO2 ? `${answer.postSpO2}%` : '_'}, HR ={' '}
              {answer.postHR ? `${answer.postHR} bpm` : '_'}
            </Typography>
            <Typography style={headerStyles}>
              Recovery: SpO2 = {answer.recoverySpO2 ? `${answer.recoverySpO2}%` : '_'}, HR ={' '}
              {answer.recoveryHR ? `${answer.recoveryHR} bpm` : '_'}
            </Typography>
          </>
        ) : null} */}
      </div>
      <div style={{ width: 40 }}>
        {answer.comment ? (
          <NoteIcon style={{ cursor: 'pointer' }} onClick={handleViewNote} />
        ) : null}
      </div>
    </div>
  );
};
